import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { ThemeService } from '../../../@prep/services/theme.service';
import { NavigationEnd, Router } from '@angular/router';
import { DashboardService } from '../../pages/dashboard/service/dashboard.service';
// Freshwork Service for Help widget Open / Close
import { NgxFreshworkWidgetService } from '../../widget/ngx-freshwork-widget/ngx-freshwork-widget.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { PlatformGlobalService } from '../service/platform-global.service';
import { Subscription } from 'rxjs';
import { CurrentUserService } from '../../pages/authentication/service/current-user.service';
import { GlobalUser } from '../model/global-user';


import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from './toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from './toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from './toolbar-multi-lang/it-IT';
import { MatTooltip } from '@angular/material/tooltip';
import { FocusMonitor } from '@angular/cdk/a11y';
import { hiddenRoutes } from '../data/vt-route-list';
import { PostLoginDepartmentDialogComponent } from 'src/app/dialog/post-login-department/post-login-department-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'prep-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [DashboardService],
})
export class ToolbarComponent implements OnInit {
  // Global User Account Info
  account: GlobalUser = new GlobalUser();

  // Toolbar Component Header Border
  @Input()
  @HostBinding('class.no-box-shadow')
  hasNavigation: boolean;

  // Mobile Sidenav Navigation 
  @Output() openSidenav = new EventEmitter();

  account_user_name: string; // Full Name of the User
  liccenseExpired = false; // License Expired

  // Prep Tool Enable
  prep_tool_enabled = false;

  // User Roles Enable
  isOrganizationAdmin = false;
  isSuperAdmin = false;
  isDepartmentAdmin = false;


  // Organmization Logo 
  dynamicImgUrl: string = '';
  dynamicimgUrlValid: boolean = false;
  logoAlttext = 'logo';

  // Navigation
  topNavigation$ = this.themeService.config$.pipe(
    map((config) => config.navigation === 'top')
  );

  // Language Selector
  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  // Help Desk 
  // @ViewChild('helpBtn', { static: false }) helpBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild(MatTooltip, { static: false }) helpBtnTooltip?: MatTooltip;

  accountToconsole: boolean = false;
  accountConsoleLabel = '';
  @Input() hideSidebarNavigation = true;
  cardsStatus = [];
  cardsPath = [
    { id: 'prep', deactive_path: ['dashboard', 'file-upload', 'usage-dashboard', 'templates', 'external-usage', 'exports', 'ce-admin', 'RSP-CE-Orders', 'RSP-Dept-Transaction', 'RSP-Dept-Team', 'Department', 'canvas-lms-files', 'civic-plus-files', 'd2l-lms-files', 'RSP-CE-Price-Config', 'RSP-Client-Deleted-Orders', 'orders', 'transcations', 'users', 'account-config-old', 'account-config', 'resources', 'report', 'ce-user-notif', 'external-contact'] },
    { id: 'rspServices', deactive_path: ['prep-rsp'] },
    { id: 'autoTag', deactive_path: ['prep-auto-tag'] },
    { id: 'rspPpr', deactive_path: ['prep-rsp-pay'] }
  ];
  constructor(
    private themeService: ThemeService,
    private freeDeskWidgetService: NgxFreshworkWidgetService,
    private dashboardService: DashboardService,
    private snackbar: MatSnackBar,
    private currentUserService: CurrentUserService,
    private platformGlobalService: PlatformGlobalService,
    public router: Router,
    private languageSelectorService: LanguageSelectorService,
    private ngZone: NgZone,
    private focusMonitor: FocusMonitor,
    private dialog: MatDialog
  ) {

  }

  ngOnInit() {

    this.languageSelectorService.language$.subscribe(lang => {
      this.selectedLang = lang;
      console.log('🌍 Language changed:', lang, lang.code, this.selectedLang.code);
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
    // Authorize
    this.currentUserService.GetCurrentUser().subscribe(
      (response) => {
        if (response.components.length > 0) {
          this.cardsStatus = response.components;
        }
        this.account_user_name =
          response.first_name +
          ' ' +
          response.last_name;
        this.platformGlobalService.me = response;
        this.account = response;
        console.log('AccountInfo', this.account, this.account.new_configs.organization.logo)
        this.checkPostLoginDepartment(this.account.new_configs.org_enabled_to_check_dept || false, this.account.new_configs.requires_dept_info || false);
        this.accountToconsole = this.account.configs.to_console;
        this.accountConsoleLabel = this.account.configs.to_console_label;
        if (this.account.configs.eula === false) {
          this.router.navigate(['/license_agreement']);
        }
        if (this.account.new_configs.organization.name) {
          this.logoAlttext = this.account.new_configs.organization.name + ' ' + 'logo';
        }
        if (this.account.new_configs.organization.logo) {
          console.log('AccountInfo Inside', this.account, this.account.new_configs.organization.logo)
          this.dynamicImgUrl = this.account.new_configs.organization.logo;
          this.checkImageUrl(this.dynamicImgUrl);
          console.log(
            'Check logo URL Value',
            this.dynamicImgUrl,
            this.dynamicimgUrlValid
          );
        }
        if (this.account.new_configs.users.enable_manage_accounts === true) {
          this.isOrganizationAdmin = true;
        } else {
          this.isOrganizationAdmin = false;
        }
        if (this.account.new_configs.plan_type === 'rsp') {
          this.prep_tool_enabled = false;
        } else {
          this.prep_tool_enabled = true;

        }
        this.checkAccess()
      },
      (error) => {
        console.log('error', error);
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    );
    console.log('myinfo', this.platformGlobalService.myUserInfo);
    if (this.platformGlobalService.myUserInfo.username) {
      const accEmail = this.platformGlobalService.myUserInfo.username;
      const accDomain = accEmail.replace(/.*@/, '');
      console.log('Domain Info', accDomain);
    }

    this.account_user_name =
      this.platformGlobalService.myUserInfo.first_name +
      ' ' +
      this.platformGlobalService.myUserInfo.last_name;
    if (this.account.new_configs?.license_expired) {
      if (this.account.new_configs.license_expired === true) {
        this.liccenseExpired = true;
      }
    }
  }

  checkPostLoginDepartment(org_enabled_to_check_dept: boolean, requires_dept_info: boolean): void {
    const deptPopupOrigins = [
      'https://newstaging-prep.netlify.app',
      'https://stanford.prep.continualengine.com',
      'http://localhost:4200'
    ];

    if (deptPopupOrigins.includes(window.location.origin)) {
      const popupInfo = {
        org_enabled_to_check_dept: org_enabled_to_check_dept,
        requires_dept_info: requires_dept_info
      };
      // popupInfo.org_enabled_to_check_dept = true;
      // popupInfo.requires_dept_info = true;
      if (popupInfo.org_enabled_to_check_dept && popupInfo.requires_dept_info) {
        const dialogRef = this.dialog.open(PostLoginDepartmentDialogComponent, {
          width: '500px',
          panelClass: 'rounded-dialog',
          backdropClass: 'dept-dialog-backdrop',
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe(() => {
          window.location.reload();
        });
      }
    } 
  }

  checkImageUrl(url: string): void {
    const img = new Image();
    img.crossOrigin = "anonymous"; // Try to bypass CORS if allowed
    img.onload = () => {
      this.dynamicimgUrlValid = true;
    };
    img.onerror = () => {
      this.dynamicimgUrlValid = false;
      console.error('Invalid image URL or CORS issue:', url);
    };
    img.src = url;
  }

  clickGoToTraning() {
    console.log(
      'item values',
      this.platformGlobalService.getStoreDashboardInfo
    );
    let videourl: string;
    const urlToken = this.platformGlobalService.getStoreDashboardInfo.url_token;
    if (urlToken !== '') {
      videourl = urlToken;
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', videourl);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.snackbar.open(
        'Training video not Available for this user',
        '',
        {
          duration: 10000,
        }
      );
    }
  }

  clickGoTpQuickStartGuide() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'assets/document/PREP-Quick-Start-Guide.pdf';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  HelpClickOLd() {
    this.freeDeskWidgetService.FreshworksWidget('hide');
    setTimeout(() => {
      this.freeDeskWidgetService.FreshworksWidget('open');
    }, 500);
  }

  helpDialogStatus = '';

  private announceHelpDialogClosed(): void {
    this.ngZone.run(() => {
      this.helpDialogStatus = '';
      setTimeout(() => { this.helpDialogStatus = 'Help dialog closed'; }, 50);
    });
  }

  // Call this after fw('hide') or when 'widget:closed' fires
  private focusBackToHelpButton(triggerBtn: HTMLButtonElement) {
    setTimeout(() => {
      triggerBtn?.focus();
    });
    // const el = this.helpBtn?.nativeElement;
    // if (!el) return;

    // // If the button is hidden at this breakpoint (fxHide/fxShow), wait & retry
    // if (!this.isVisibleAndFocusable(el)) {
    //   if (retries > 0) {
    //     return setTimeout(() => this.focusBackToHelpButton(retries - 1), 75);
    //   }
    //   return; // give up silently
    // }

    // // Prevent tooltip stealing focus
    // try { this.helpBtnTooltip?.hide(0); } catch { }
    // // Ensure focusable
    // if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');

    // // Use CDK FocusMonitor for keyboard-like focus (announces to SR)
    // this.ngZone.runOutsideAngular(() => {
    //   requestAnimationFrame(() => {
    //     requestAnimationFrame(() => {
    //       this.ngZone.run(() => {
    //         // If your page scrolls, avoid jumps:
    //         try { el.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch { }
    //         this.focusMonitor.focusVia(el, 'keyboard'); // <-- key line
    //         this.announceHelpDialogClosed();
    //       });
    //     });
    //   });
    // });
  }

  private isVisibleAndFocusable(el: HTMLElement): boolean {
    // Must be in the document
    if (!document.body.contains(el)) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    // fxHide often sets display:none; offsetParent null can catch many hidden states
    if (el.offsetParent === null && style.position !== 'fixed') return false;
    // width/height > 0
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return true;
  }

  HelpClick(helpBtn: HTMLButtonElement) {
    const fw = this.freeDeskWidgetService.FreshworksWidget;

    // Avoid duplicate handlers
    try { fw('off', 'widget:closed'); } catch { }

    // Focus return when widget is actually closed (best signal)
    try { fw('on', 'widget:closed', () => this.focusBackToHelpButton(helpBtn)); } catch { }

    fw('hide');
    setTimeout(() => {
      fw('open');

      setTimeout(() => {
        const iframe = document.querySelector<HTMLIFrameElement>('iframe#widget-frame, iframe[id*="freshwidget-"]');
        if (!iframe) return;

        // Land focus inside the widget
        iframe.tabIndex = -1;
        iframe.focus();

        try {
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!doc) throw new Error();

          const contactBtn =
            doc.querySelector<HTMLElement>('button[data-testid="contact-us"], [data-testid="contact-us"]');
          const closeEl =
            doc.querySelector<HTMLElement>('[data-testid="header-close"], .WidgetHeader__CloseWrapper-e8xmgj-3, [aria-label="Close"], [title="Close"]');
          const sendBtn =
            doc.querySelector<HTMLElement>('#form-button, button[data-testid="form-button"]');

          // Make sure key elements are focusable
          contactBtn?.setAttribute('tabindex', '0');
          closeEl?.setAttribute('tabindex', '0');
          sendBtn?.setAttribute('tabindex', '0');

          // patch article list items to be keyboard focusable 
          this.patchArticleListItems(doc);
          

          (contactBtn || closeEl || sendBtn || doc.body).focus();

          const getFocusable = () =>
            Array.from(
              doc.querySelectorAll<HTMLElement>(
                [
                  'a[href]',
                  'button:not([disabled])',
                  'input:not([disabled])',
                  'select:not([disabled])',
                  'textarea:not([disabled])',
                  '[tabindex]:not([tabindex="-1"])',
                  // include article list items in the focusable set
                  '[data-testid^="article-list-item-"]'
                ].join(',')
              )
            ).filter(el => el.offsetParent !== null || getComputedStyle(el).position === 'fixed');

          const trapKeydown = (e: KeyboardEvent) => {
            // Escape -> close widget and return focus to Help button
            if (e.key === 'Escape') {
              e.preventDefault();
              fw('hide');
              setTimeout(() => this.focusBackToHelpButton(helpBtn), 250);
              return;
            }
            if (e.key !== 'Tab') return;
            const focusables = getFocusable();
            if (!focusables.length) return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            // If Shift+Tab on first -> wrap to last
            if (e.shiftKey && doc.activeElement === first) {
              e.preventDefault();
              last.focus();
              return;
            }
            // If Tab on last -> wrap to first
            if (!e.shiftKey && doc.activeElement === last) {
              e.preventDefault();
              first.focus();
              return;
            }
            // Otherwise, allow normal Tab within iframe
          };

          // Attach trap on the iframe doc (capture = true to beat inner handlers)
          doc.addEventListener('keydown', trapKeydown, true);

          // re-patch article items whenever the widget re-renders (e.g. search results update)
          const mo = new MutationObserver(() => {
            this.patchArticleListItems(doc);
          });
          mo.observe(doc.body, { subtree: true, childList: true });

          // === Close & Send: hide and return focus =======================
          const activateAndReturn = (e: Event | KeyboardEvent) => {
            e.preventDefault();
            fw('hide');
            setTimeout(() => this.focusBackToHelpButton(helpBtn), 250);
          };

          // Close
          closeEl?.addEventListener('click', activateAndReturn as EventListener, { capture: true });
          closeEl?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') activateAndReturn(e);
          }, { capture: true });

          // Send
          sendBtn?.addEventListener('click', activateAndReturn as EventListener, { capture: true });
          sendBtn?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') activateAndReturn(e);
          }, { capture: true });

          // Optional: Contact → Tab moves to Close (as you wanted earlier)
          contactBtn?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Tab' && !e.shiftKey && closeEl) {
              e.preventDefault();
              closeEl.focus();
            }
          }, { capture: true });

        } catch {
          // Cross-origin fallback: can’t trap inside; observe close then focus back
          this.observeCloseThenFocusBack(helpBtn);
        }
      }, 600);
    }, 250);
  }

  // patch article list items — tabindex + keyboard activation ───────────
  // Finds all Freshdesk suggested-article items inside the widget iframe document
  // and makes them keyboard-focusable and activatable via Enter/Space.
  // Uses a WeakSet to avoid attaching duplicate listeners when MutationObserver
  // triggers this method on re-renders.
  private _patchedArticleItems = new WeakSet<HTMLElement>();

  private patchArticleListItems(doc: Document): void {
    const items = doc.querySelectorAll<HTMLElement>('[data-testid^="article-list-item-"]');
    items.forEach(item => {
      // Skip already patched elements
      if (this._patchedArticleItems.has(item)) return;

      // Make focusable if not already a native interactive element
      if (!item.hasAttribute('tabindex')) {
        item.setAttribute('tabindex', '0');
      }

      // Expose as a button to assistive technologies if not already a semantic role
      if (!item.getAttribute('role')) {
        item.setAttribute('role', 'button');
      }

      // Activate on Enter or Space — mirrors native button behaviour
      item.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      }, { capture: true });

      this._patchedArticleItems.add(item);
    });
  }
  // ─────────────────────────────────────────────────────────────────────────────

  private observeCloseThenFocusBack(triggerBtn: HTMLButtonElement) {
    const start = performance.now();
    const sel = 'iframe#widget-frame, iframe[id*="freshwidget-"]';
    const isClosed = () => {
      const f = document.querySelector<HTMLIFrameElement>(sel);
      if (!f) return true;
      const s = getComputedStyle(f);
      return s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0';
    };
    const poll = () => {
      if (isClosed() || performance.now() - start > 2000) this.focusBackToHelpButton(triggerBtn);
      else setTimeout(poll, 50);
    };
    poll();
  }

  checkAccess(): void {
    const currentUrl = this.router.url;

    const pathMap = new Map(
      this.cardsPath.map(item => [item.id, item.deactive_path])
    );

    const isBlocked = this.cardsStatus.some(item => {
      const paths = pathMap.get(item.id) || [];
      return (
        item.status === 'Inactive' &&
        paths.some(path => currentUrl.includes(path))
      );
    });

    if (isBlocked) {
      this.router.navigate(['/vt-dashboard']);
    }
  }
}
